import { useActiveScenario, useScenarioRun } from "@/hooks/world";

/** Results for what the app is showing: the active scenario's run, or Baseline when none is active. */
export function useViewResult() {
	const { scenario } = useActiveScenario();
	const res = useScenarioRun(scenario?.id);
	return { ...res, scenario };
}

/** "just now", "5 min ago", "3 hours ago", "2 days ago", then a date. */
export function ago(iso: string, now = Date.now()): string {
	const s = Math.max(0, (now - new Date(iso).getTime()) / 1000);
	if (s < 60) return "just now";
	if (s < 3600) return `${Math.floor(s / 60)} min ago`;
	if (s < 86400) {
		const h = Math.floor(s / 3600);
		return `${h} ${h === 1 ? "hour" : "hours"} ago`;
	}
	if (s < 86400 * 7) {
		const d = Math.floor(s / 86400);
		return d === 1 ? "yesterday" : `${d} days ago`;
	}
	return new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short" });
}
